export default __webpack_public_path__ + "static/media/Vazir-Bold.3305d400.woff";